import React from 'react'

export const Checkbox = ({ label, checked, onChange, className = '' }) => {
  return (
    <label className={`group flex cursor-pointer items-center space-x-2 ${className}`}>
      <div className="relative">
        <input type="checkbox" checked={checked} onChange={onChange} className="sr-only" />
        <div
          className={`h-5 w-5 rounded-md border shadow drop-shadow-sm backdrop-blur-sm group-hover:shadow-md ${checked ? 'border-accent-400 bg-accent-400' : 'border-b-0 border-r-0 border-white/50 bg-white/50 group-hover:bg-white/80'} transition-all`}
        ></div>
        {checked && (
          <div className="absolute inset-0 flex items-center justify-center">
            <svg
              className="h-3 w-3 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={4}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
        )}
      </div>
      {label && <span className="text-sm font-medium text-gray-700">{label}</span>}
    </label>
  )
}
